var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"MChatDefaultMessage"},[_c('div',{staticClass:"msg content"},[_c('p',[_vm._v("📫")]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('dict.chatDefaultMessage'))}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }